var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcDownWhiteLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83728 11.4018C8.44203 12.0008 7.56317 12.0008 7.16793 11.4018L4.40702 7.21749C3.96833 6.55263 4.44515 5.66675 5.2417 5.66675L10.7635 5.66675C11.5601 5.66675 12.0369 6.55263 11.5982 7.21749L8.83728 11.4018Z",
    fill: "#000"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownWhiteLight);
export default __webpack_public_path__ + "static/media/ic_down_whiteLight.ad7245f677b3ff046c08c13fe61d166d.svg";
export { ForwardRef as ReactComponent };